import styled from 'styled-components';

export const PromotionWrapper = styled.div.attrs({
  role: 'status',
})`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 40px;
  height: 30px;
  ${props => props.mobileBackgroundImage && `background-image: url("${props.mobileBackgroundImage}")`};
  background-position: center bottom;
  background-repeat: no-repeat;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    ${props => props.backgroundImage && `background-image: url("${props.backgroundImage}")`};
  }

  ${props => props.css};
`;

export const PromotionInner = styled.div`
  position: relative;
`;

export const Image = styled.img`
  ${props => props.css};
`;

export const Message = styled.span`
  color: ${props => props.theme.carvana.white.primary};
  font-size: 14px;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    font-size: 16px;
  }

  ${props => props.css};
`;

export const Button = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 20px;
  height: 19px;
  min-width: 84px;
  border-radius: 3px;
  box-shadow: none;
  font-size: 10px;
  font-weight: 700;
  margin: 0;
  text-decoration: none;
  text-transform: uppercase;
  transition: background-color 200ms, color 200ms;

  background-color: ${props => props.theme.carvana.white.primary};
  color: ${props => props.theme.carvana.blue.primary};

  &:hover {
    color: ${props => props.theme.carvana.blue.hover};
    cursor: pointer;
    text-decoration: none;
  }

  ${props => props.css};
`;

export const Copyright = styled.span`
  font-size: 9px;
  font-weight: 400;
  color: ${props => props.theme.carvana.white.primary};
  line-height: 15px;
  text-transform: uppercase;
  ${props => props.css};
`;
